export default "__VITE_ASSET__f701aee6__"